import { useMatch } from "react-router-dom";
import * as pathnames from "../../../constants/pathnames";

const useIsLinkSelected = () => {
  const isDashboardSelected = !!useMatch({
    path: pathnames.dashboard,
    exact: true,
    strict: true
  });

  const isPrepaymentSelected = !!useMatch({
    path: pathnames.prepayment,
    exact: true,
    strict: true
  });

  let isPaymentsSelected = !!useMatch({
    path: pathnames.payments,
    exact: true,
    strict: true
  });

  isPaymentsSelected =
    !!useMatch({
      path: pathnames.payment,
      exact: true,
      strict: true
    }) || isPaymentsSelected;

  let isInvoicesSelected = !!useMatch({
    path: pathnames.main,
    exact: true,
    strict: true
  });

  isInvoicesSelected =
    !!useMatch({
      path: pathnames.invoice,
      exact: false,
      strict: true
    }) || isInvoicesSelected;

  const isInvoiceProcessingSelected = !!useMatch({
    path: pathnames.invoiceProcessing,
    exact: true,
    strict: true
  });

  const isInvoiceCreationSelected = !!useMatch({
    path: pathnames.invoiceCreation,
    exact: true,
    strict: true
  });

  return {
    isDashboardSelected,
    isPaymentsSelected,
    isInvoicesSelected,
    isPrepaymentSelected,
    isInvoiceProcessingSelected,
    isInvoiceCreationSelected
  };
};

export default useIsLinkSelected;
